export enum OpportunityCommunicationTypeOption {
  PROCESS = 'ab038b7a-0fa5-42b5-addb-d1e87f4572fc',
  CHAT = '6a13888f-d2ca-4152-aaf7-d73d7a3bd3ec',
}

export enum CommunicationTypeOption {
  CONTRACT_BUILDER = 'a85c83c9-f793-4ae9-9e78-d07365cc72d6'
}
